/* eslint-disable arrow-body-style */
import React from 'react';
import PropTypes from 'prop-types';
import { translateElementChildren } from 'utils/translation';

const I = ({ children, translationKey, defaultText, ...rest }) => {
  return (
    <i {...rest}>
      {translateElementChildren(children, translationKey, defaultText)}
    </i>
  );
};

I.propTypes = {
  children: PropTypes.node.isRequired,
  translationKey: PropTypes.string,
  defaultText: PropTypes.string,
};

export default I;
